// extracted by mini-css-extract-plugin
export var container = "_8b-0";
export var containerTopRight = "_8b-1";